module.exports = __webpack_public_path__ + "officialStatic/img/index-product-gw.d78fd4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-gw.png
// module id = mrdb
// module chunks = 0